import { render, staticRenderFns } from "./TravelDetailsCN.vue?vue&type=template&id=113f55fc"
import script from "./TravelDetailsCN.vue?vue&type=script&lang=js"
export * from "./TravelDetailsCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports